var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("aside", { staticClass: "product-delivery-info" }, [
      _c("ul", [
        _c("li", [
          !_vm.producOutOfStock && _vm.languageStrings.in_stock
            ? _c(
                "div",
                { staticClass: "product-promises-item stock-availability" },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.languageStrings.in_stock) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("li", [
          _vm.producOutOfStock
            ? _c(
                "div",
                {
                  staticClass:
                    "product-promises-item stock-availability out-of-stock",
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.languageStrings.out_of_stock) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        !_vm.appSettings.engraving_options
          ? _c("li", [
              !_vm.checkIfLaser()
                ? _c(
                    "div",
                    { staticClass: "product-promises-item gravure-icon" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.languageStrings.laquer_engraving) +
                          "\n        "
                      ),
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "product-promises-item laser-icon" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.languageStrings.laser_engraving) +
                          "\n        "
                      ),
                    ]
                  ),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.interfaceList.length > 0
        ? _c(
            "div",
            _vm._l(_vm.interfaceList, function (interfaceItem, index) {
              return _c("div", { key: index }, [
                interfaceItem === "sign_interface_tape"
                  ? _c(
                      "div",
                      { staticClass: "product-promises-item tape-included" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.languageStrings.tape_included_short) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                interfaceItem === "sign_interface_militaryclip"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "product-promises-item militaryclip-included",
                      },
                      [_vm._v("\n          Militärfäste\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                interfaceItem === "sign_interface_screw"
                  ? _c(
                      "div",
                      { staticClass: "product-promises-item screws-included" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.languageStrings.screws_included_short) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                interfaceItem === "sign_interface_safetypin"
                  ? _c(
                      "div",
                      {
                        staticClass: "product-promises-item safetypin-included",
                      },
                      [_vm._v("\n          Säkerhetsnål\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                interfaceItem === "sign_interface_metalmagnet"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "product-promises-item militaryclip-included",
                      },
                      [_vm._v("\n          Magnet metall\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                interfaceItem === "sign_interface_plasticmagnet"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "product-promises-item militaryclip-included",
                      },
                      [_vm._v("\n          Magnet plast\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                interfaceItem === "sign_interface_keyring"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "product-promises-item militaryclip-included",
                      },
                      [_vm._v("\n          Nyckelring\n        ")]
                    )
                  : _vm._e(),
              ])
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }